// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__KyseN","label":"Category_label__1TeaH","content":"Category_content__1gMLY","header":"Category_header__3GK5Z","location":"Category_location__3XkEt"};